import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'ZenCore',
  brandName: 'ZenCore',
  description: 'Sistema de agendamento para massagistas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Sala de massagem relaxante',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Massagista atendendo cliente',
  },
  testimonials: [
    {
      name: 'Isabel Rocha',
      role: 'Massagista Terapêutica',
      text: 'O ZenCore permite que os meus clientes marquem as sessões de forma calma e privada, o que é perfeito para o meu negócio.',
      image: testimonial1,
    },
    {
      name: 'Paulo Dias',
      role: 'Cliente',
      text: 'Finalmente posso marcar as minhas massagens sem ter de telefonar. O sistema é muito relaxante de usar.',
      image: testimonial2,
    },
    {
      name: 'Espaço Zen',
      role: 'Centro de Terapias',
      text: 'Gerir vários terapeutas e salas tornou-se simples. As marcações nunca foram tão organizadas.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'massoterapeuta',
    professionals: 'massoterapeutas',
    business: 'spa',
    businesses: 'spas',
    service: 'massagem',
    services: 'massagens',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'sessão',
    appointments: 'sessões',
  },
  homepage: {
    hero: {
      badge: 'Bem-estar & Relaxamento',
      title: 'Proporcione tranquilidade com ZenCore',
      description: 'Gerencie suas sessões de massagem e ofereça momentos únicos de relaxamento com o ZenCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '280+', label: 'Massoterapeutas' },
      { value: '22k+', label: 'Sessões Realizadas' },
      { value: '99%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Agenda Stressante',
        description: 'Gerir horários manualmente gera stress, contradizendo o ambiente de relaxamento do spa.',
        icon: 'Brain',
        quote: {
          text: 'Antes do ZenCore o stress da agenda afetava meu estado mental e a qualidade das massagens',
          author: 'Fernanda Lima',
          business: 'Zen Terapias',
        },
      },
      {
        title: 'Interrupções Durante Sessões',
        description: 'Telefones tocando durante massagens quebram o ambiente relaxante e afetam a experiência.',
        icon: 'PhoneOff',
        stats: [
          { label: 'Interrupções diárias sem sistema:', value: '15+' },
          { label: 'Clientes insatisfeitos:', value: '35%' },
        ],
      },
      {
        title: 'Preparação de Ambiente',
        description: 'Sem aviso prévio do tipo de massagem, a preparação adequada do espaço fica comprometida.',
        icon: 'Settings',
        quote: {
          text: 'Sabendo antecipadamente o tipo de massagem consigo preparar óleos e ambiente perfeito',
          author: 'Carlos Mendes',
          business: 'Refúgio Spa',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'ZenCore: O seu santuário digital',
      description: 'Tecnologia serena para massoterapeutas que valorizam tranquilidade e qualidade.',
      features: [
        {
          title: 'Reservas Silenciosas',
          description: 'Clientes marcam sessões online sem interromper o ambiente relaxante do spa.',
        },
        {
          title: 'Preparação Personalizada',
          description: 'Saiba antecipadamente o tipo de massagem e preferências para preparar tudo perfeitamente.',
        },
        {
          title: 'Lembretes Suaves',
          description: 'Notificações discretas que mantêm a harmonia do ambiente terapêutico.',
        },
      ],
    },
    testimonials: {
      title: 'O que os massoterapeutas dizem',
      description: 'Massoterapeutas que encontraram paz e organização com o ZenCore.',
    },
    finalCta: {
      title: 'Pronto para criar harmonia em seu spa?',
      description: 'Junte-se aos massoterapeutas que encontraram serenidade na gestão com o ZenCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de massoterapeuta',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
